import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image } from "react-bootstrap";
import LadyFreeThinker from "../../../assests/images/nonprofit-success-stories-images/lady-free-thinker.webp";
import {
    NonprofitSuccessStoriesSection,
    FeaturedSuccessStoriesSection,
    FeaturedSuccessStoriesWrap,
    FeaturedSuccessStoriesTitle,
    FeaturedStoriesWrap,
    FeaturedStoriesBox,
    FeaturedStoriesImage,
    FeaturedStoriesContent,
    FeaturedStoriesSubTitle,
    FeaturedStoriesSubText
} from "./successStoriesStyle"
import { useDispatch,useSelector } from "react-redux";
import { successStoriesHandler } from "../../../redux/slices/nonProfit/success-stories";
import {
    Title,
    WriteReviewSection,
    ReviewText,
    ReviewRightSection,
    RightBanner,
    } from "../../../components/common/commonSubBanner/commonSubBannerStyle";
import SuccessStoriesBanner from "../../../assests/images/success-stories-banner.webp";
import { MESSAGE } from "../../../utils/message";
import MetaComponent from "../../../components/common/metaComponent";
const SuccessStories = () => {
    const dispatch:any = useDispatch()
    const successStoriesList = useSelector((state:any) => state?.successStories?.data)
    useEffect(() => {
       dispatch(successStoriesHandler())
    },[])

    return (
        <>
        <MetaComponent 
            keywords=""
            description=""
            ogTitle="Nonprofit Success Stories | GreatNonprofits"
            ogDescription=""
            ogUrl="https://www.about.greatnonprofits.org/nonprofit-success-stories"
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
         <>
<NonprofitSuccessStoriesSection>
    <WriteReviewSection>
        <Container className="cont-w"> 
            <Row>
                <Col lg={6} md={6} sm={12}>
                    <Title>Nonprofit Success Stories</Title>
                    <ReviewText>We've rounded up a few examples of the ways that gathering reviews has helped organizations to reach new supporters, highlight their accomplishments, and gain valuable feedback. If you've got a success story to add, please email us. We are always excited to learn about the new and creative ways nonprofits use their reviews! </ReviewText>
                </Col>
                <Col lg={6} md={6} sm={12}>
                    <RightBanner className="left_banner">
                        <ReviewRightSection>
                            <Image src={SuccessStoriesBanner} alt="ReviewImage"/>
                        </ReviewRightSection>
                    </RightBanner>
                </Col>
            </Row>
        </Container>
    </WriteReviewSection>
</NonprofitSuccessStoriesSection>

<FeaturedSuccessStoriesSection>
    <Container className="cont-w">
        <Row>
            <Col lg="12">
                <FeaturedSuccessStoriesWrap>
                    <FeaturedSuccessStoriesTitle>{MESSAGE.featuredSuccessStories}</FeaturedSuccessStoriesTitle>

                    <FeaturedStoriesWrap>
                        {
                       successStoriesList?.data?.map((story:any, index:number) => (
                                <FeaturedStoriesBox key={index+1}>
                                <FeaturedStoriesImage>
                                    <Image src={LadyFreeThinker} alt="Lady Free Thinker" />
                                </FeaturedStoriesImage>

                                <FeaturedStoriesContent>
                                    <FeaturedStoriesSubTitle>{story.storyName}</FeaturedStoriesSubTitle>
                                    <FeaturedStoriesSubText>{story.location}</FeaturedStoriesSubText>
                                    <FeaturedStoriesSubText>{story.storyDetail}</FeaturedStoriesSubText>
                                </FeaturedStoriesContent>

                            </FeaturedStoriesBox>
                            ))
                        }
                    </FeaturedStoriesWrap>

                </FeaturedSuccessStoriesWrap>
            </Col>
        </Row>
    </Container>
</FeaturedSuccessStoriesSection>

</>
        </>
   )
};
export default SuccessStories;